import {
  AccountVuex,
  AccountVuexState,
} from "@/shared/vuex/store/account.vuex";
import { createLogger, createStore } from "vuex";
import {
  InvitationsVuex,
  InvitationsVuexState,
  QuestionsVuex,
  QuestionsVuexState,
  UsersVuex,
  UsersVuexState,
} from "./modules";
import { AdminBiddingsVuex, AdminBiddingsVuexState } from "./modules/biddings.vuex";
import { AdminBusinessesVuex, AdminBusinessesVuexState } from "./modules/businesses.vuex";
import { AdminOpportunitiesVuex, AdminOpportunitiesVuexState } from "./modules/opportunities.vuex";
import {
  AdminTransactionsVuex,
  AdminTransactionsVuexState,
} from "./modules/transactions";

export interface AdminAppState {
  account: AccountVuexState;
  users: UsersVuexState;
  questions: QuestionsVuexState;
  invitations: InvitationsVuexState;
  transactions: AdminTransactionsVuexState;
  businesses: AdminBusinessesVuexState;
  biddings: AdminBiddingsVuexState;
  opportunities: AdminOpportunitiesVuexState;
}
/**
 *
 */
export const AdminStore = createStore<AdminAppState>({
  plugins: [createLogger({})],
  modules: {
    account: AccountVuex as any,
    users: UsersVuex as any,
    questions: QuestionsVuex as any,
    invitations: InvitationsVuex as any,
    transactions: AdminTransactionsVuex as any,
    businesses: AdminBusinessesVuex as any,
    biddings: AdminBiddingsVuex as any,
    opportunities: AdminOpportunitiesVuex as any,
  },
});

export default AdminStore;
